import { TERMINAL_ID } from "@/constants/EngineConstants";
import { Offer } from "@/types/offer";
import { PopularDestination } from "@/types/popularDestination";
import { replaceBookingUrl } from "@/utils/urlUtils";

export const getPopularDestinationsFromOffers = (
  offer: Offer,
  index: number
): PopularDestination => {

  return {
    id: offer.destinationId,
    rank: index + 1,
    city: offer.destination,
    image: offer.imageUrl,
    url: `${replaceBookingUrl(offer.url)}?terminalId=${TERMINAL_ID}`,
  }
};
